import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TurbineSpinnerComponent } from "@dcc/vestas-design-system/angular/components/turbine-spinner";
import { UserStore } from "@dcc/vestas-online/data-access";

@Component({
    selector: "vo-shell-root",
    templateUrl: "./root.component.html",
    imports: [RouterOutlet, TurbineSpinnerComponent]
})
export class RootComponent {
    private readonly userStore = inject(UserStore);
    protected readonly loading = this.userStore.loading;
}
